import Image from 'next/image'
import React from 'react'

import Button from './button'

import { handRaise } from '@/libs/constants/images-library'

export type TWelcomeModal = {
  readonly state: 'home' | 'guest_home' | 'survey'
  readonly isOpen: boolean
  readonly onClose?: () => void
  readonly isGuest: boolean
}

export default function WelcomeModal({ state, isOpen, onClose, isGuest = false }: TWelcomeModal) {
  const welcomeGuides = {
    home: {
      image: handRaise,
      title: isGuest ? 'Welcome to Survey!' : 'Welcome to Responova!',
      description: `Let's take a quick tour to help you navigate the survey platform effortlessly.`,
    },
    guest_home: {
      image: null,
      title: 'Welcome!',
      description: `Let's take a quick tour to help you navigate the survey platform effortlessly.`,
    },
    survey: {
      image: null,
      title: 'Explore Survey Details',
      description: `Welcome to your first survey! You're now on the survey detail page. Let's break it down.`,
    },
  }[state]

  return (
    <div>
      {isOpen && (
        <>
          <div className='fixed inset-0 z-[999] flex items-center justify-center'>
            <div className='z-50 mx-5 w-full overflow-y-auto rounded-3xl bg-white shadow-lg md:w-1/2 xl:w-4/12'>
              <div className='mx-auto flex w-full flex-col items-start justify-start gap-2 px-6 py-4'>
                {welcomeGuides?.image && (
                  <Image
                    src={handRaise.src}
                    width={160}
                    height={160}
                    alt={handRaise.alt}
                    className='mx-auto'
                  />
                )}
                <h1 className='text-left text-lg font-semibold'>{welcomeGuides?.title}</h1>
                <p className='text-left text-sm font-light text-pop-neutral-gray'>
                  {welcomeGuides?.description}
                </p>
                <div className='mt-3 flex w-full flex-row justify-around'>
                  <Button
                    id='next_button'
                    name='next_button'
                    variant='contained'
                    onClick={onClose}
                    type='button'
                    aria-label='Next'
                  >
                    <span>Next</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fixed inset-0 z-40 bg-gray-500 opacity-75'></div>
        </>
      )}
    </div>
  )
}
